import { useGetSessionContextQuery } from '@common/services/session';
import { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

export const RequireSession = () => {
  const { showBoundary } = useErrorBoundary();
  const { data: context, error } = useGetSessionContextQuery();

  useEffect(() => {
    if (!error || error.status === 401) return;

    console.error('La session utilisateur n\'a pas pu être vérifiée.');
    showBoundary(error.error || error.message || error);
  }, [error]);

  return (context) ? <Outlet /> : <></>;
};
